import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { EmployeePosition } from './types';

export const PositionSummary: React.FC<
  React.PropsWithChildren<{
    currentPosition: EmployeePosition;
    selectedPosition: EmployeePosition | null;
    selectedPositionId: string;
    t: (key: string, options?: { defaultValue?: string }) => string;
  }>
> = ({ currentPosition, selectedPosition, selectedPositionId, t }) => {
  const isNewPositionSelected =
    selectedPositionId !== currentPosition.Id &&
    !selectedPosition?.isCurrentPosition;

  return (
    <div className="bg-light rounded p-3">
      <Row>
        <Col md={6}>
          <div className="small text-muted fw-bold text-uppercase">
            {t('currentPosition')}
          </div>
          <div className="fw-bold">{currentPosition.flair__Title__c}</div>
        </Col>
        <Col md={6}>
          <div className="small text-muted fw-bold text-uppercase">
            {t('newPosition')}
          </div>
          {isNewPositionSelected ? (
            <div className="fw-bold">
              {selectedPosition?.flair__Title__c || '-'}
            </div>
          ) : (
            <div className="fw-bold text-muted">-</div>
          )}
        </Col>
      </Row>
    </div>
  );
};
